import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
//import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Router, Route } from 'react-router-dom';
import {connect, Provider} from 'react-redux';
import store from './Store';
import MainView from './components/views/MainView';
import PWForVehicleOwner from './components/views/PWForVehicleOwner';
import PWForTowTruck from "./components/views/PWForTowTruck";
import PWForCity from "./components/views/PWForCity";
import PWForPrivacy from "./components/views/PWForPrivacy";
import PWForOptout from "./components/views/PWForOptout";
import ContactUs from "./components/views/ContactUs";
import Signup from "./components/views/Signup";
import HOAs from "./components/views/HOAs";
import Campus from "./components/views/Campus";
import Apartment from "./components/views/Apartment";
import Auth from './Auth/Auth';
import Callback from './Callback/Callback';
import PropTypes from 'prop-types'
import history from './history';
import { handleAuthenticationAction, updateUserProfileAction} from "./redux/modules/login";
import {bindActionCreators} from "redux";
import { ThemeProvider, createMuiTheme, makeStyles } from '@material-ui/core/styles';


const theme = createMuiTheme();

/*const useStyles = makeStyles((theme) => {
  root: {
    // some CSS that accesses the theme
  }
});*/


/*const handleAuthentication = ({location}) => {
    if (/access_token|id_token|error/.test(location.hash)) {
        this.props.auth.handleAuthentication();
    }
}
*/
/*import Flight, { Rect } from 'react-flight/dom'


Flight.contextTypes = {
    store: PropTypes.object,
}

Flight.childContextTypes = {
    ...Flight.childContextTypes,
    store: PropTypes.object,
}
*/

//const auth = new Auth();




class App extends Component {


    constructor(props) {
        super(props);
        //this.handleAuthentication =this.handleAuthentication.bind(this);
    }


  /* old one  handleAuthentication(location){
        //if (/access_token|id_token|error/.test(location.hash)) {
            auth.handleAuthentication();
        //}
    }
    */

   /* oldnotneededrender() {

        return (
            <Provider store={store}>
            <Router history={history}>
            <div>
            <Route path='/' exact={true} render={(props) => <MainView {...props} auth={auth} />}/>
        <Route path='/home' render={(props) => <MainView {...props} auth={auth} /> }/>
        <Route path="/callback" render={(props) => {
            this.handleAuthentication(props);
            return <MainView {...props} auth={auth}/>
        }}/>

        </div>
        </Router>
        </Provider>
    );

    } */

    render() {
        let { handleAuthenticationAction } = this.props;
        return (
          <ThemeProvider theme={theme}>{
            <Provider store={store}>
            
            <Router history={history}>
            <div>
        <meta name="viewport" content="width=device-width" initial-scale="1.00" maximum-scale="1.0" />
                <Route path='/' exact={true} render={(props) => <MainView {...props}  />}/>
                <Route path='/home' render={(props) => <MainView {...props} /> }/>
                <Route path='/vehicle' render={(props) => <PWForVehicleOwner {...props} /> }/>
                <Route path='/towcompany' render={(props) => <PWForTowTruck {...props} /> }/>
                <Route path='/citydetails' render={(props) => <PWForCity {...props} /> }/>
              <Route path='/error' render={(props) => <MainView {...props} /> }/>
              <Route path='/privacy' render={(props) => <PWForPrivacy {...props} /> }/>
                <Route path='/hoas' render={(props) => <HOAs {...props} /> }/>
                <Route path='/apartment' render={(props) => <Apartment {...props} /> }/>
                <Route path='/campus' render={(props) => <Campus {...props} /> }/>
              <Route path='/optout' render={(props) => <PWForOptout {...props} /> }/>
              <Route path='/contactus' render={(props) => <ContactUs {...props} /> }/>
              <Route path='/signup' render={(props) => <Signup {...props} /> }/>
                <Route path="/callback" render={(props) => {
              handleAuthenticationAction(props);
                return <MainView {...props} />
              }}/>

            </div>
        </Router>
                
               
                  </Provider>
          }</ThemeProvider>
    );

  }
}


const mapStateToProps = (state) => {
    return {
        //accountsArray: state.account.accountsArray,
        //CompanyDeleteResponse:state.account.deleteCompanyResp,
        //CompanySaveResponse:state.account.saveCompanyResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        //errorCMsg:state.account.errorCMsg,
        //loginData:state.login.loginData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        //login:login,
        handleAuthenticationAction:handleAuthenticationAction,
        //updateUserProfileAction:updateUserProfileAction,


    }, dispatch);
};


//export default App;

export default connect(mapStateToProps, mapDispatchToProps)(App);
